<template>
    <div class="fee">
         <div class="profile border-top">
            <div class="profile__left">
                <div class="profile__title">Transaction Type</div>
                <div class="profile__caption">This will apply to transactions in the selected module</div>
            </div>
            <div class="profile__right">
                <Dropdown  title="Transaction Type" :label="transactionType" :options="transactionTypes" :onOptionSelected="({ id }) => this.transactionType = id" />
            </div>
        </div>
        <div class="profile fee">
            <div class="profile__left">
                <div class="profile__title">Fee Rules</div>
                <div class="profile__caption"></div>
            </div>
            <div class="profile__right">
                <div class="form__flex">
                    <div class="form__flex__item">
                        <label class="form__label" for>Fee Property</label>
                        <div class="select">
                            <select class="select__input" v-model="feeProperty.value">
                                <option value="total_merchant_amount">Total Merchant Amount</option>
                                <option value="total_merchant_volume">Total Merchant Volume</option>
                                <option value="total_nuban_amount">Total Nuban Amount</option>
                                <option value="total_nuban_volume">Total Nuban Volume</option>
                                <option value="amount">Amount</option>
                                <option value="hour">Hour</option>
                                <option value="nuban">Nuban</option>
                            </select>
                            <div class="select__icon">
                                <svg fill="none" height="6" viewBox="0 0 10 6" width="10" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.29289 0.292893C8.68342 -0.0976311 9.31658 -0.0976311 9.70711 0.292893C10.0976 0.683418 10.0976 1.31658 9.70711 1.70711L5.70711 5.70711C5.31658 6.09763 4.68342 6.09763 4.29289 5.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893C0.683418 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L5 3.58579L8.29289 0.292893Z" fill="#261940" opacity="0.6" />
                                </svg>
                            </div>
                        </div>
                        <span class="attention" v-if="feeProperty.empty">Field can't be empty</span>
                    </div>
                    <div class="form__flex__item">
                        <label class="form__label" for>Fee Rule Priority</label>
                        <div class="select">
                            <select class="select__input" v-model="feeIndex.value">
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                            </select>
                            <div class="select__icon">
                                <svg fill="none" height="6" viewBox="0 0 10 6" width="10" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.29289 0.292893C8.68342 -0.0976311 9.31658 -0.0976311 9.70711 0.292893C10.0976 0.683418 10.0976 1.31658 9.70711 1.70711L5.70711 5.70711C5.31658 6.09763 4.68342 6.09763 4.29289 5.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893C0.683418 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L5 3.58579L8.29289 0.292893Z" fill="#261940" opacity="0.6" />
                                </svg>
                            </div>
                        </div>
                        <span class="attention" v-if="feeIndex.empty">Field can't be empty</span>
                    </div>
                </div>
                <div class="form__flex">
                    <div class="form__flex__item">
                        <label class="form__label" for>Fee Rule</label>
                        <div class="select">
                            <select class="select__input" v-model="feeRule.value">
                                <option value="EQ">Equals</option>
                                <option value="LT">Less than</option>
                                <option value="GT">Greater than</option>
                                <option value="LTE">Less than or equal to</option>
                                <option value="GTE">Greater than or equal to</option>
                                <option value="CNT">Contains</option>
                                <option value="NCNT">Does not contain</option>
                            </select>
                            <div class="select__icon">
                                <svg fill="none" height="6" viewBox="0 0 10 6" width="10" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.29289 0.292893C8.68342 -0.0976311 9.31658 -0.0976311 9.70711 0.292893C10.0976 0.683418 10.0976 1.31658 9.70711 1.70711L5.70711 5.70711C5.31658 6.09763 4.68342 6.09763 4.29289 5.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893C0.683418 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L5 3.58579L8.29289 0.292893Z" fill="#261940" opacity="0.6" />
                                </svg>
                            </div>
                        </div>
                        <span class="attention" v-if="feeRule.empty">Field can't be empty</span>
                    </div>
                    <div class="form__flex__item">
                        <label class="form__label" for>Fee Rule Value</label>
                        <money class="form__input" v-model="feeRuleValue.value"></money>
                        <span class="attention" v-if="feeRuleValue.empty">Field can't be empty</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="profile">
            <div class="profile__left">
                <div class="profile__title">Fee Applied</div>
                <div class="profile__caption">Fee Applied due to Fee Rule</div>
            </div>
            <div class="profile__right">
                <div class="form__flex">
                    <div class="form__flex__item">
                        <label class="form__label" for>Fee Type</label>
                        <div class="select">
                            <select class="select__input" v-model="feeType.value">
                                <option value="FLAT">Flat</option>
                                <option value="PERCENT">Percentage</option>
                            </select>
                            <div class="select__icon">
                                <svg fill="none" height="6" viewBox="0 0 10 6" width="10" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.29289 0.292893C8.68342 -0.0976311 9.31658 -0.0976311 9.70711 0.292893C10.0976 0.683418 10.0976 1.31658 9.70711 1.70711L5.70711 5.70711C5.31658 6.09763 4.68342 6.09763 4.29289 5.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893C0.683418 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L5 3.58579L8.29289 0.292893Z" fill="#261940" opacity="0.6" />
                                </svg>
                            </div>
                        </div>
                        <span class="attention" v-if="feeType.empty">Field can't be empty</span>
                    </div>
                    <div class="form__flex__item">
                        <label class="form__label" for>Fee</label>
                        <money class="form__input" v-model="fee.value"></money>
                        <span class="attention" v-if="fee.empty">Field can't be empty</span>
                    </div>
                </div>
                <div class="form__flex">
                    <div class="form__flex__item">
                        <label class="form__label" for>Minimum Charge</label>
                        <money class="form__input" v-model="minimumCharge.value"></money>
                        <span class="attention" v-if="minimumCharge.empty">Field can't be empty</span>
                    </div>
                    <div class="form__flex__item">
                        <label class="form__label" for>Maximum Charge</label>
                        <money class="form__input" v-model="maximumCharge.value"></money>
                        <span class="attention" v-if="maximumCharge.empty">Field can't be empty</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="profile">
            <div class="profile__left">
                <div class="profile__title">Assign Bank Fee</div>
                <div class="profile__caption"></div>
            </div>
            <div class="profile__right">
                       <div class="form__item">
                    <label class="form__label" for>Select Bank</label>
                    <div class="select">
                        <select class="select__input select__input--noborder" v-model="bank_code.value">
                            <option :key="key" :value="bank.code" v-for="(bank, key) in bankList">{{bank.bank}}</option>
                        </select>
                        <div class="select__icon">
                            <svg height="10" viewBox="0 0 6 10" width="6" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z" fill="#637381" fill-rule="evenodd" />
                            </svg>
                        </div>
                    </div>
                    <span class="attention" v-if="bank_code.empty">Field can't be empty</span>
                </div>
                <div class="form__flex">
                    <div class="form__flex__item">
                        <label class="form__label" for>Bank Fee Type</label>
                        <div class="select">
                            <select class="select__input" v-model="bankfeeType.value">
                                <option value="FLAT">Flat</option>
                                <option value="PERCENT">Percentage</option>
                            </select>
                            <div class="select__icon">
                                <svg fill="none" height="6" viewBox="0 0 10 6" width="10" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.29289 0.292893C8.68342 -0.0976311 9.31658 -0.0976311 9.70711 0.292893C10.0976 0.683418 10.0976 1.31658 9.70711 1.70711L5.70711 5.70711C5.31658 6.09763 4.68342 6.09763 4.29289 5.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893C0.683418 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L5 3.58579L8.29289 0.292893Z" fill="#261940" opacity="0.6" />
                                </svg>
                            </div>
                        </div>
                        <span class="attention" v-if="bankfeeType.empty">Field can't be empty</span>
                    </div>
                    <div class="form__flex__item">
                        <label class="form__label" for>Fee Bank</label>
                        <money class="form__input" v-model="bankfee.value"></money>
                        <span class="attention" v-if="bankfee.empty">Field can't be empty</span>
                    </div>
                </div>
              <div class="form__flex">
                    <div class="form__flex__item">
                        <label class="form__label" for>Collections Account No</label>
                        <input class="form__input"  type="text" v-model="collection_account.value" />
                        <span class="attention" v-if="bankfee.empty">Field can't be empty</span>
                    </div>
                    <div class="form__flex__item">
                        <label class="form__label" for>Woven Fee Account No</label>
                        <input  class="form__input" maxlength="11" type="text" v-model="woven_fee_account.value" />
                        <span class="attention" v-if="bankfee.empty">Field can't be empty</span>
                    </div>
                </div>
                  <div class="form__flex">
                    <div class="form__flex__item small">
                        <label class="form__label" for>Bank Fee Account No</label>
                        <input class="form__input"  type="text" v-model="bank_fee_account.value" value="" />
                        <span class="attention" v-if="bankfee.empty">Field can't be empty</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="action">
            <button :disabled="disabled" @click="createFee" class="btn btn--primary" v-if="isCreate">Save Changes</button>
            <button :disabled="disabled" @click="editFee" class="btn btn--primary" v-else-if="!isCreate">Save Changes</button>
        </div>
    </div>
</template>

<script>
import Dropdown from "@/components/dropdown"

export default {
    metaInfo: {
        title: "Settings - Fee",
    },
    components: {
        Dropdown
    },
    data() {
        return {
            transactionTypes: [
              {
                  id: 'vnuban payment',
                  value: "vNUBAN Payment"
              },
              {
                  id: 'merchant vnuban funding',
                  value: 'Merchant vNUBAN Funding'
              },
              {
                  id: 'customer vnuban funding',
                  value: 'Customer vNUBAN Funding'
              },
              {
                  id: 'payout',
                  value: 'Payout Transaction'
              },
             {
                  id: 'direct debit',
                  value: 'Direct Debit'
              },
            ],
            fee: "",
            transactionType: '',
            disabled: false,
            feeType: {
                value: "select",
                empty: false,
            },
            bankfeeType: {
                value: "select",
                empty: false,
            },
            wovenfeeType: {
                value: "select",
                empty: false,
            },
            feeProperty: {
                value: "select",
                empty: false,
            },
            fee: {
                value: "",
                empty: false,
            },
            bankfee: {
                value: "",
                empty: false,
            },
            wovenfee: {
                value: "",
                empty: false,
            },
            feeRule: {
                value: "select",
                empty: false,
            },
            bank_code: {
                value: "",
                empty: false,
            },
            wovenBank: {
                value: "",
                empty: false,
            },
            feeDestination: {
                value: "",
                empty: false,
            },
            feeIndex: {
                value: "",
                empty: false,
            },
            feeRuleValue: {
                value: "",
                empty: false,
            },
            maximumCharge: {
                value: "",
                empty: false,
            },
            minimumCharge: {
                value: "",
                empty: false,
            },
            collection_account: {
                value: "",
                empty: false
            },
            woven_fee_account: {
                value: '',
                empty: false
            },
            bank_fee_account: {
                value: '',
                empty: false
            },
            decision: this.$route.path === `/dashboard/merchants/${this.$route.params.id}/edit/fee/add` ? "CREATE" : "EDIT",
            disabled: false,
            feeMetaResponse: "",
            rootNuban: "",
        };
    },

    computed: {
        bankList() {
            return this.$store.state.bankList;
        },

        subAccounts() {
            return this.$store.state.subAccounts;
        },
        isCreate() {
            return this.$route.path === `/dashboard/merchants/${this.$route.params.id}/edit/fee/add`
        }
    },

    created() {

        this.fetchFee();
        // Fetch Profile
        // this.$store.dispatch("fetchProfile").then((response) => {
        //     this.rootNuban = response.business_nuban;
        // });
        // // Fetch subaccounts
        // this.$store.dispatch("fetchSubAccounts");
        this.setDecision()
    },

    methods: {
        setDecision() {
            if(this.$route.path === `/dashboard/merchants/${this.$route.params.id}/edit/fee/add`) {
               this.decision = 'CREATE' 
            } else {
               this.decision = 'EDIT'  
            }
        },
        createFee() {
            this.resetFields();
            if (true) {
                this.disabled = true;
                let requestObject = {
                    transaction_type: this.transactionType,
                    merchantId: this.$route.params.id,
                    default_fee: Math.abs(this.fee.value),
                    default_fee_type: this.feeType.value,
                    // fee_account_nuban: this.feeDestination.value,
                    bank_code: this.bank_code.value,
                    fee_meta: {
                        fee_rules: [
                            {
                                prop: this.feeProperty.value,
                                index: this.feeIndex.value,
                                condition: this.feeRule.value,
                                value: Math.abs(this.feeRuleValue.value),
                                fee: Math.abs(this.fee.value),
                                fee_type: this.feeType.value,
                            },
                        ],
                        min_fees: Math.abs(this.minimumCharge.value),
                        max_fees: Math.abs(this.maximumCharge.value),
                        fee_split_rules: {
                            bank: {
                                type: this.bankfeeType.value,
                                value: Math.abs(this.bankfee.value),
                            },
                        },
                    },
                    bank_fee_account: this.bank_fee_account.value,
                    collection_account: this.collection_account.value,
                    woven_fee_account: this.woven_fee_account.value
                };

                this.$http
                    .post("admin/fees", requestObject)
                    .then((response) => {
                        this.disabled = false;
                        this.$notify({
                            group: "notifications-default",
                            type: "success text-white",
                            title: "Success",
                            text: response.body.message,
                        });
                    })
                    .catch((error) => {
                        this.disabled = false;
                        this.$notify({
                            group: "notifications-default",
                            type: "error text-white",
                            title: "Error",
                            text: error.body.message,
                        });
                    });
            } else {
                if (this.feeProperty.value == "select") {
                    this.feeProperty.empty = true;
                }
                if (this.feeType.value == "select") {
                    this.feeType.empty = true;
                }
                if (this.fee.value == "") {
                    this.fee.empty = true;
                }
                if (this.feeRule.value == "select") {
                    this.feeRule.empty = true;
                }
                if (this.bank_code.value == "") {
                    this.bank_code.empty = true;
                }
                if (this.feeDestination.value == "") {
                    this.feeDestination.empty = true;
                }
                if (this.feeIndex.value == "") {
                    this.feeIndex.empty = true;
                }
                if (this.feeRuleValue.value == "") {
                    this.feeRuleValue.empty = true;
                }
            }
        },

        editFee() {
            this.resetFields();
            if (true) {
                this.disabled = true;
                let requestObject = {
                    transaction_type: this.transactionType,
                    merchantId: 0,
                    default_fee: Math.abs(this.fee.value),
                    default_fee_type: this.feeType.value,
                    // fee_account_nuban: this.feeDestination.value,
                     bank_code: this.bank_code.value,
                    fee_meta: {
                        fee_rules: [
                            {
                                prop: this.feeProperty.value,
                                index: this.feeIndex.value,
                                condition: this.feeRule.value,
                                value: Math.abs(this.feeRuleValue.value),
                                fee: Math.abs(this.fee.value),
                                fee_type: this.feeType.value,
                            },
                        ],
                        min_fees: Math.abs(this.minimumCharge.value),
                        max_fees: Math.abs(this.maximumCharge.value),
                        fee_split_rules: {
                            bank: {
                                type: this.bankfeeType.value,
                                value: Math.abs(this.bankfee.value),
                            },
                        },
                    },
                    bank_fee_account: this.bank_fee_account.value,
                    collection_account: this.collection_account.value,
                    woven_fee_account: this.woven_fee_account.value
                };

                this.$http
                    .put(`admin/fees?feeId=${this.$route.params.feeId}`, requestObject)
                    .then((response) => {
                        this.disabled = false;
                        this.$notify({
                            group: "notifications-default",
                            type: "success text-white",
                            title: "Success",
                            text: response.body.message,
                        });
                    })
                    .catch((error) => {
                        this.disabled = false;
                        this.$notify({
                            group: "notifications-default",
                            type: "error text-white",
                            title: "Error",
                            text: error.body.message,
                        });
                    });
            } else {
                if (this.feeProperty.value == "select") {
                    this.feeProperty.empty = true;
                }
                if (this.feeType.value == "select") {
                    this.feeType.empty = true;
                }
                if (this.fee.value == "") {
                    this.fee.empty = true;
                }
                if (this.feeRule.value == "select") {
                    this.feeRule.empty = true;
                }
                if (this.bank_code.value == "") {
                    this.bank_code.empty = true;
                }
                if (this.feeDestination.value == "") {
                    this.feeDestination.empty = true;
                }
                if (this.feeIndex.value == "") {
                    this.feeIndex.empty = true;
                }
                if (this.feeRuleValue.value == "") {
                    this.feeRuleValue.empty = true;
                }
            }
        },

        fetchFee() {
            let requestObject = {
                merchantId: 0,
            };

            if(this.decision === 'EDIT') {
            this.$http
                .get(`admin/fees?feeId=${this.$route.params.feeId}`, requestObject)
                .then((response) => {
                    let item = response.body.data.fees[0];
                    const feeMeta = item.fee_meta ? JSON.parse(item.fee_meta) : {}

                    const feeRules = feeMeta.fee_rules;
     
                    this.feeProperty.value = feeRules &&  feeRules[0].prop ? feeRules[0].prop : '';
                    this.feeIndex.value = feeRules && feeRules[0].index ? feeRules[0].index : '';
                    this.feeRule.value = feeRules && feeRules[0].condition  ? feeRules[0].condition : '';
                    this.feeRuleValue.value = feeRules && feeRules[0].value ? feeRules[0].value : '';
                    this.fee.value = feeRules ? feeRules.fee : '';
                    this.feeType.value = feeRules && feeRules[0].fee_type ? feeRules[0].fee_type : '';
                    this.minimumCharge.value = feeMeta && feeMeta.min_fees ? feeMeta.min_fees : '';
                    this.maximumCharge.value = feeMeta  && feeMeta.max_fees? feeMeta.max_fees : '';
                    this.bankfeeType.value = feeMeta && feeMeta.fee_split_rules ? feeMeta.fee_split_rules.bank.type : '';
                    this.bankfee.value =  feeMeta && feeMeta.fee_split_rules ? feeMeta.fee_split_rules.bank.value : '';
                    this.bank_code.value = item.fee_account_bank;
                    this.decision = "EDIT";
                    this.transactionType = item.transaction_type
                    this.collection_account.value = item.collection_account
                    this.woven_fee_account.value = item.woven_fee_account
                    this.bank_fee_account.value = item.bank_fee_account
                    this.bank_code.value = item.bank_code
                    this.transactionType = item.transaction_type
                    this.fee.value = item.default_fee
                })
                .catch((error) => {
                    this.decision = "CREATE";
                });
            }


        },

        resetFields() {
            this.feeProperty.empty = false;
            this.feeType.empty = false;
            this.fee.empty = false;
            this.feeRule.empty = false;
            this.bank_code.empty = false;
            this.feeDestination.empty = false;
            this.feeIndex.empty = false;
            this.feeRuleValue.empty = false;
        },
    },
};
</script>
<style lang="scss">
.fee {
    .drop-down {
        width: 100%;
        height: 64px;
    }

    .dropdown-options {
        width: 100%;
    }
}

.profile {
    &__right {
        position: relative;
    }
}

.small {
    margin-left: 0 !important;
    width: 180px !important;
}
</style>